import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { DataGrid, filteredColumnDefsBuilder, GridId } from 'view/components/datagrid'
import { productSectorMappingDetailSelector, productSectorMappingDraftDetailSelector } from 'selectors/productSelectors'
import { SectorMappingColumnDefs, sectorMappingGridOptions } from './SectorMappingGridModel'
import { SectorMappingDraftButton } from './SectorMappingDraftButton'
import { showDraftMappingSelector } from 'selectors/globalGridSelectors'
import { SectorMappingActions } from './SectorMappingActions'
import { Locale, Translation } from 'locale'

export const SectorMappingGrid: React.FC = () => {
  const sectorMappingList = useSelector(productSectorMappingDetailSelector)
  const sectorMappingDraftList = useSelector(productSectorMappingDraftDetailSelector)
  const draftView = useSelector(showDraftMappingSelector)
  const filteredColumnDefs = useMemo(() => filteredColumnDefsBuilder(SectorMappingColumnDefs(draftView)).build(), [draftView])

  return (
    <DataGrid
      gridId={GridId.AdminSectorGrid}
      key={draftView ? Locale.translate(Translation.TC_SECTOR_DRAFT_MAPPINGS) : Locale.translate(Translation.TC_SECTOR_CURRENT_MAPPINGS)}
      gridOptions={sectorMappingGridOptions}
      disableGrouping={true}
      rowData={draftView ? sectorMappingDraftList : sectorMappingList}
      columnDefs={filteredColumnDefs}
      subscriptionFilters={() => (
        <>
          <SectorMappingDraftButton />
          {draftView && <SectorMappingActions />}
        </>
      )}
    />
  )
}
